export enum NewsKind {
	Article = "Article",
	Comparison = "Comparison",
	CaseStudy = "CaseStudy",
}
